module.exports = __webpack_public_path__ + "static/img/013.b3191e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-eplus/013.png
// module id = ZmlN
// module chunks = 1